var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{key:_vm.$route.meta.key || _vm.$route.fullPath,tag:"component",class:("view--sub" + (_vm.slug ? ("--" + _vm.slug) : ''))})}
var staticRenderFns = []

export { render, staticRenderFns }